module.exports = __webpack_public_path__ + "static/img/step1.efeffe60.png";